import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';

import { useTranslation } from '@shared/core';
import { SortComponent } from './SortComponent';
import type { SortOption } from '@shared/constants/accommodations';
import { TOOLBAR_PILL_PROPS } from '@shared/utils/style/toolbarPill';
import type { DesktopListingsHeaderExtras } from './DeskTopListingsHeader.types';
import { COLLAPSIBLE_FILTERS_PANEL_ID } from '../../FiltersPanel/CollapsibleFiltersPanel';

type Props = DesktopListingsHeaderExtras &
  Readonly<{
    accentColor?: string;
    sortOption: SortOption;
    includeCouplesPicks: boolean;
    includeFundSavings?: boolean;
    onSortChange: (sort: SortOption) => void;
  }>;

const DeskTopListingsHeader: React.FC<Props> = ({ sortOption, onSortChange, includeCouplesPicks, includeFundSavings, accentColor, title, filtersToggle, currencySelector }) => {
  const { t, tq } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      gap={5}
    >
      <TextV2 typographyVariant="hed4">{title ?? listingTrans.title()}</TextV2>
      <Flex
        gap={3}
        flexShrink={0}
        alignItems="center"
      >
        {filtersToggle && (
          <ButtonV2
            intent="neutral"
            variant="outline"
            {...TOOLBAR_PILL_PROPS}
            onClick={filtersToggle.onToggle}
            aria-expanded={filtersToggle.isOpen}
            aria-controls={COLLAPSIBLE_FILTERS_PANEL_ID}
          >
            {filtersToggle.isOpen ? tq`Hide Filters` : tq`Filters`}
          </ButtonV2>
        )}
        {currencySelector}
        <SortComponent
          onChange={onSortChange}
          accentColor={accentColor}
          selectedValue={sortOption}
          includeFundSavings={includeFundSavings}
          includeCouplesPicks={includeCouplesPicks}
          appearance={filtersToggle || currencySelector ? 'pill' : 'default'}
        />
      </Flex>
    </Flex>
  );
};

export default DeskTopListingsHeader;
